/**
 * Загрузка аналитики (Top.Mail.Ru и др.) только после согласия на cookies (ФЗ-152).
 * Cookie-файлы относятся к ПДн, аналитика не должна загружаться до согласия.
 */

const TMR_LOADED_KEY = 'analytics_tmr_loaded';

let tmrLoaded = false;

/** Счётчик своего сайта: у сборки «только проверки» он отдельный, без него не грузим */
const TMR_COUNTER_ID: string =
  process.env.REACT_APP_EDITION === 'checks'
    ? process.env.REACT_APP_TOP_MAIL_RU_ID || ''
    : '3733427';

/**
 * Загружает счётчик Top.Mail.Ru. Вызывать только после получения согласия на cookies.
 */
export function loadTopMailRuCounter(): void {
  if (typeof window === 'undefined' || tmrLoaded || !TMR_COUNTER_ID) return;
  if (document.getElementById('tmr-code')) return;

  tmrLoaded = true;
  try {
    sessionStorage.setItem(TMR_LOADED_KEY, '1');
  } catch {
    /* ignore */
  }

  const _tmr = (window as any)._tmr || ((window as any)._tmr = []);
  _tmr.push({
    id: TMR_COUNTER_ID,
    type: 'pageView',
    start: new Date().getTime(),
  });

  const ts = document.createElement('script');
  ts.type = 'text/javascript';
  ts.async = true;
  ts.id = 'tmr-code';
  ts.src = 'https://top-fwz1.mail.ru/js/code.js';
  const s = document.getElementsByTagName('script')[0];
  if (s?.parentNode) {
    s.parentNode.insertBefore(ts, s);
  }
}

/**
 * Яндекс Метрика сайта «только проверки». У основного сайта счётчик стоит
 * прямо в public/index.html, поэтому в основной сборке здесь пусто.
 */
const YANDEX_METRIKA_ID: number =
  process.env.REACT_APP_EDITION === 'checks'
    ? Number(process.env.REACT_APP_YANDEX_METRIKA_ID || 113441924)
    : 0;

let metrikaLoaded = false;

type YmFn = ((...args: unknown[]) => void) & { a?: unknown[][]; l?: number };

/** Загружает Метрику. Вызывать только после согласия на cookies. */
export function loadYandexMetrika(): void {
  if (typeof window === 'undefined' || metrikaLoaded || !YANDEX_METRIKA_ID) return;
  metrikaLoaded = true;

  // Официальный сниппет Метрики
  const w = window as unknown as { ym?: YmFn };
  const src = `https://mc.yandex.ru/metrika/tag.js?id=${YANDEX_METRIKA_ID}`;
  if (!w.ym) {
    const ym: YmFn = function (...args: unknown[]) {
      (ym.a = ym.a || []).push(args);
    };
    ym.l = Date.now();
    w.ym = ym;
  }
  if (![...document.scripts].some((script) => script.src === src)) {
    const tag = document.createElement('script');
    tag.async = true;
    tag.src = src;
    const first = document.getElementsByTagName('script')[0];
    if (first?.parentNode) first.parentNode.insertBefore(tag, first);
    else document.head.appendChild(tag);
  }

  w.ym!(YANDEX_METRIKA_ID, 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    referrer: document.referrer,
    url: window.location.href,
    accurateTrackBounce: true,
    trackLinks: true,
  });
}

/** Просмотр страницы при переходе внутри приложения (SPA) — для Метрики */
export function trackPageView(url: string, referer: string): void {
  const w = window as unknown as { ym?: YmFn };
  if (!metrikaLoaded || !YANDEX_METRIKA_ID || !w.ym) return;
  w.ym(YANDEX_METRIKA_ID, 'hit', url, { referer });
}

/** Вся аналитика, которой пользователь дал согласие */
export function loadConsentedAnalytics(): void {
  loadTopMailRuCounter();
  loadYandexMetrika();
}

/**
 * Цель Метрики. Срабатывает, если счётчик уже есть на странице (подключён
 * в index.html или после согласия на cookie); иначе молча ничего не делает.
 */
export function reachMetrikaGoal(goal: string, params?: Record<string, unknown>): void {
  const w = window as unknown as { ym?: YmFn };
  if (!YANDEX_METRIKA_ID || typeof w.ym !== 'function') return;
  w.ym(YANDEX_METRIKA_ID, 'reachGoal', goal, params);
}
